import { Pipe, PipeTransform } from '@angular/core'
import { LocalDate, localDate, LocalDateInput } from '@naturalcycles/js-lib'
import { LANG } from '@naturalcycles/shared'

function defaultFormatDate(d: LocalDate | LocalDateInput, locale: LANG): string {
  return localDate(d)
    .format(
      new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    )
    .replace(/\s/g, '\u00A0') // non-breaking space
    .replace(/,/g, '')
}

@Pipe({
  name: 'ncDate',
  standalone: true,
})
export class NcDatePipe implements PipeTransform {
  transform(d: LocalDateInput, locale: LANG): string {
    return defaultFormatDate(d, locale)
  }
}
